import { Component, Input } from '@angular/core';
import { ChartDataset } from 'chart.js';
import moment from 'moment';
import { DataTableColumn } from 'src/app/shared/components';
import { SearchWeeklySummaryDto } from 'src/app/shared/dto';

@Component({
    selector: 'app-searches-card',
    templateUrl: './searches-card.component.html',
    styleUrls: ['../../../common-reporting-dashboard.scss'],
    standalone: false
})
export class SearchesCardComponent {
    @Input() isShowChart: boolean;
    @Input()
    set searchSummary(data: SearchWeeklySummaryDto[]) {
        this._searchSummary = data;
        this.updateChart();
    };
    get searchSummaryData(): SearchWeeklySummaryDto[] {
        return this._searchSummary;
    }

    searchColumns: DataTableColumn[] = [
        {
            dataField: 'weekStart',
            caption: 'Week',
            cellTemplate: 'dateTemplate',
            width: '10%',
            cellClasses: 'border-b-0 pb-1 px-4',
            headerCellClasses: '',
            dateFormat: 'MM/dd/yy'
        },
        {
            dataField: 'revdriverSearchCount',
            caption: 'RevDriver Searches',
            cellTemplate: 'numberTemplate',
            width: '32%',
            allowSorting: false,
            cellClasses: 'border-b-0 pb-1 px-4 text-center pr-6',
            headerCellClasses: 'p-0',

        },
        {
            dataField: 'portalSearchCount',
            caption: 'Web App Searches',
            cellTemplate: 'numberTemplate',
            width: '30%',
            allowSorting: false,
            cellClasses: 'border-b-0 pb-1 px-4 text-center pr-6',
            headerCellClasses: 'p-0',
        },
        {
            dataField: 'totalSearchCount',
            caption: 'Total Searches',
            cellTemplate: 'numberTemplate',
            width: '26%',
            allowSorting: false,
            cellClasses: 'border-b-0 pb-1 px-4 text-center pr-6',
            headerCellClasses: 'p-0',
        },
    ];

    chartLabels: string[] = []
    stackChartData: ChartDataset<'bar'>[] = [];

    private _searchSummary: SearchWeeklySummaryDto[];

    updateChart(): void {
        if (this._searchSummary && this._searchSummary.length > 0) {
            this.chartLabels = this._searchSummary.map(entry => moment(entry.weekStart, 'YYYY-MM-DD').format('MM/DD/YY').toString());

            const portalSearchData = this._searchSummary.map(entry => entry.portalSearchCount);
            const revdriverSearchData = this._searchSummary.map(entry => entry.revdriverSearchCount);

            this.stackChartData = [
                {
                    label: 'Web App',
                    data: portalSearchData,
                    backgroundColor: '#3F6BB4'
                },
                {
                    label: 'RevDriver',
                    data: revdriverSearchData,
                    backgroundColor: '#FF994E'
                }
            ];
        }
    }

}
